import { useToast } from '@app/core/notifications';
import { useWebAppInsertCuepointYoutubeIntegrationCuepoints } from '@mi-front/api-v2';
import { useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import { youtubeCuepointsMessages } from '../messages/youtube-cuepoints-messages';

interface UseInsertYoutubeCuepointOptions {
  stationId: string;
  listId: string;
  onSuccess?: () => void;
}

/**
 * Wraps the BFF insert-cuepoint mutation with list invalidation and user feedback.
 */
export function useInsertYoutubeCuepoint({
  stationId,
  listId,
  onSuccess,
}: UseInsertYoutubeCuepointOptions) {
  const { $t } = useIntl();
  const { notifySuccess, notifyError } = useToast();
  const queryClient = useQueryClient();

  const mutation = useWebAppInsertCuepointYoutubeIntegrationCuepoints();

  const insertCuepoint = async (durationSecs: number) => {
    try {
      await mutation.mutateAsync({
        station: stationId,
        data: { durationSecs },
      });

      await queryClient.invalidateQueries({ queryKey: [listId] });

      notifySuccess($t(youtubeCuepointsMessages.insertSuccess));
      onSuccess?.();
    } catch (error) {
      notifyError($t(youtubeCuepointsMessages.insertError));
      console.error('Failed to insert YouTube cuepoint:', error);
      throw error;
    }
  };

  return {
    insertCuepoint,
    isPending: mutation.isPending,
  };
}
